import React from 'react'
import { AnonymousAvatar, AvatarV2 } from '@mote/ui'

export type RecorderAvatarProps =
  | { isAnonymous: true }
  | {
      isAnonymous: false
      name: string
      avatarUrl: string
    }

export function RecorderAvatar(props: RecorderAvatarProps) {
  return props.isAnonymous ? (
    <AnonymousAvatar size={'xl'} />
  ) : (
    <AvatarV2
      size={'xl'}
      name={props.name}
      alt={`user-avatar-${props.name}`}
      src={props.avatarUrl}
    />
  )
}
